import "./blog.css";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectUserLanguage } from "../../features/user/userSlice";
import useLanguage from "../../hooks/useLanguage";
import HambMenu from "../../components/hamburger-menu/HambMenu";
import BlogEntry from "../../components/blog-entry/BlogEntry";
import { useNavigate } from "react-router-dom";

const Blog = () => {
  const currentLanguage = useSelector(selectUserLanguage) || "es";
  const navigate = useNavigate();
  // Get texts based on current language
  const texts = useLanguage(currentLanguage, "views.landingPage");

  const [showMenu, setShowMenu] = useState(false);

  const handleNavigate = (id) => {
    navigate(`/blog/${id}`);
  };

  return (
    <>
      <Header
        texts={texts}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        inLandingPage={false}
      />
      {!showMenu ? (
        <div className="blog-container">
          <div className="blog-header">
            <div className="blog-header-entry">
              <h1>¿Por qué la sustentabilidad importa hoy más que nunca?</h1>
              <p>
                En un mundo donde el cambio climático y la pérdida de
                biodiversidad son desafíos cada vez más urgentes, adoptar
                prácticas sustentables se ha vuelto una prioridad. Desde reducir
                el consumo de plásticos hasta optar por energías limpias, cada
                pequeña acción cuenta. La sustentabilidad no solo trata del
                medio ambiente...
              </p>
              <div className="blog-header-entry-content-bottom">
                <div className="blog-entry-button">Sustentabilidad</div>
                <span className="blog-entry-date">Julio 31, 2025</span>
              </div>
            </div>
          </div>
          <div className="blog-recent-posts">
            <h2>También te puede interesar</h2>
            <div className="blog-recent-posts-list">
              <BlogEntry />
              <BlogEntry />
              <BlogEntry />
              <BlogEntry />
              <BlogEntry />
              <BlogEntry />
            </div>
          </div>
          <Footer inLandingPage={false} />
        </div>
      ) : (
        <HambMenu
          showMenu={showMenu}
          setShowMenu={setShowMenu}
          inLandingPage={false}
        />
      )}
    </>
  );
};

export default Blog;
